import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/catalogueStyles.css";
import { Button, Modal } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

const DownloadCatalogue = () => {
  const [show, setShow] = useState(false);
  const [successModal, setSuccessModal] = useState(false);

  const handleClose = () => setShow(false);
  const handleSuccessClose = () => setSuccessModal(false);

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phonenumber: "",
      location: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      phonenumber: Yup.string()
        .matches(/^[0-9]{10,15}$/, "Phone number must be 10-15 digits")
        .required("Phone number is required"),
      location: Yup.string().required("Location is required"),
    }),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        const response = await fetch(
          "https://api.mytimewatch.com/api/catalogue/send-catalogue",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(values),
          }
        );
    
        if (response.ok) {
          // Trigger file download
          const downloadLink = document.createElement("a");
          downloadLink.href = "https://drive.google.com/uc?export=download&id=1eMVypZUZCh26EXle3M0Uj3VDbLzJNNgG";
          downloadLink.download = "Catalogue.pdf";
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          
    
          // Optional: show success modal
          handleClose();
          setSuccessModal(true);
          setTimeout(() => setSuccessModal(false), 3000);
    
          resetForm();
        } else {
          alert("Something went wrong. Please try again.");
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setSubmitting(false);
      }
    }
    
  });

  return (
    <div className="container-fluid d-flex flex-column justify-content-center align-items-center p-2 bg-none">
      <div className="text-center mb-4">
        <h3 className="catalogue-subheading">
          Unlock the Best in Security – Get Our Catalogue Now
        </h3>
      </div>
      <div className="text-center mb-4">
        <img
          className="catalogue-image"
          src="https://timewatch.co.in/images/catalogue.webp"
          alt="catalogue"
          width={400}
          height={263}
          
        />
      </div>
      <div className="text-center">
        <button
          type="button"
          className="btn btn-primary download-button"
          onClick={() => setShow(true)}
        >
          Get the Catalogue
        </button>
      </div>

      <Modal show={show} onHide={handleClose} centered animation>
        <Modal.Header style={{ borderBottom: "none" }} closeButton>
          <Modal.Title>Download Catalogue</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={formik.handleSubmit}>
            {["name", "email", "phonenumber", "location"].map((field) => (
              <div key={field} className="mb-3">
               
                <label
                  htmlFor={field}
                  className="form-label fw-bold"
                >
                  {field === "phonenumber" ? "Phone Number" : field.charAt(0).toUpperCase() + field.slice(1)}
                </label>
                <input
                  id={field}
                  name={field}
                  className="form-control"
                  value={formik.values[field]}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched[field] && formik.errors[field] && (
                  <div className="text-danger">{formik.errors[field]}</div>
                )}
              </div>
            ))}
            <Button
              type="submit"
              disabled={formik.isSubmitting}
              style={{
                backgroundColor: "#f14144",
                borderColor: "#f14144",
              }}
            >
              {formik.isSubmitting ? "Downloading..." : "Download"}
            </Button>
          </form>
        </Modal.Body>
      </Modal>

      {/* Success Modal */}
      <Modal
        show={successModal}
        onHide={handleSuccessClose}
        centered
        animation
        dialogClassName="modal-dialog-centered"
      >
        <Modal.Body className="d-flex flex-column align-items-center w-100 mb-0 text-center">
          <div
            style={{
              width: "50px",
              height: "50px",
              backgroundColor: "#11B823",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <i
              className="fas fa-check"
              style={{ color: "white", fontSize: "24px" }}
            ></i>
          </div>
          <h3 className="fw-bold">Success</h3>
          We've received your request. You will receive an email with the
          catalogue shortly.
        </Modal.Body>
        <Modal.Footer
          className="d-flex justify-content-center w-100"
          style={{ borderTop: "none" }}
        >
          <Button
            style={{
              backgroundColor: "#11B823",
              borderColor: "#11B823",
              width: "100%",
            }}
            onClick={handleSuccessClose}
          >
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DownloadCatalogue;
